import moment from 'moment';
import { toast } from "react-toastify";

const formatDateRangeLabel = (startDate: Date | null = null, endDate: Date | null = null, failFormate: boolean = true) => {
    if (!startDate || !endDate) return "Select Date Range";
  
    const today = moment();
    const start = moment(startDate);
    const end = moment(endDate);
  
    if (start.isSame(today, 'day') && end.isSame(today, 'day')) {
      return "Today";
    } else if (start.isSame(today.clone().subtract(1, 'day'), 'day') && end.isSame(today.clone().subtract(1, 'day'), 'day')) {
      return "Yesterday";
    } else if (start.isSame(today.startOf('week'), 'day') && end.isSame(today.endOf('week'), 'day')) {
      return "This Week";
    } else if (start.isSame(today.clone().subtract(1, 'week').startOf('week'), 'day') && end.isSame(today.clone().subtract(1, 'week').endOf('week'), 'day')) {
      return "Last Week";
    } else if (start.isSame(today.startOf('month'), 'day') && end.isSame(today.endOf('month'), 'day')) {
      return "This Month";
    } else if (start.isSame(today.clone().subtract(1, 'month').startOf('month'), 'day') && end.isSame(today.clone().subtract(1, 'month').endOf('month'), 'day')) {
      return "Last Month";
    } else if (start.isSame(today.startOf('year'), 'day') && end.isSame(today.endOf('year'), 'day')) {
      return "This Year";
    } else if (start.isSame(today.clone().subtract(1, 'year').startOf('year'), 'day') && end.isSame(today.clone().subtract(1, 'year').endOf('year'), 'day')) {
      return "Last Year";
    } else {

      if (failFormate) {
        const formattedStartDate = start.format('MMM D');
        const formattedEndDate = end.format('MMM D');
        return `${formattedStartDate} - ${formattedEndDate}`;
      } else {
        return '';
      }
      
    }
  };

export default formatDateRangeLabel;





export const aggresiveToastError = (error: any) => {
  let errorMessage = '';

  if (Array.isArray(error.response.data)) {
    errorMessage = error.response.data.join(", ");
  } else if (Array.isArray(error.response.data.non_field_errors)) {
    errorMessage = error.response.data.non_field_errors.join(", ");
  } else if (error.response.data.non_field_errors) {
    errorMessage = error.response.data.non_field_errors;
  } else if (error.response.data.detail) {
    errorMessage = error.response.data.detail;
  } else {
    errorMessage = Object.values(error.response.data).join(", ");
  }

  toast.error(errorMessage);
}




export const formatCurrency = (amount: number, currency = "USD", locale = "en-US") => {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency,
  }).format(amount);
};
